<script lang="ts">
  import { fly } from 'svelte/transition';
  import { router } from './lib/router.svelte';
  import Header from './components/Header.svelte';
  import Footer from './components/Footer.svelte';
  import TestPage from './pages/TestPage.svelte';
  import SharePage from './pages/SharePage.svelte';
  import HistoryPage from './pages/HistoryPage.svelte';
  import MethodPage from './pages/MethodPage.svelte';
  import LegalPage from './pages/LegalPage.svelte';
  import NotFound from './pages/NotFound.svelte';

  // Pages secondaires chargées à la demande (budget de la page de test).
  const Observatory = () => import('./pages/ObservatoryPage.svelte');
  const Portal = () => import('./portal/PortalApp.svelte');
  const Admin = () => import('./admin/AdminApp.svelte');
  const legal = ['mentions-legales', 'confidentialite', 'conditions', 'accessibilite', 'opendata'];

  const titles: Record<string, string> = {
    '/': 'Test de débit',
    '/historique': 'Historique',
    '/observatoire': 'Observatoire',
    '/methodologie': 'Méthodologie',
  };
  $effect(() => {
    const p = router.path;
    const t = titles[p] ?? (p.startsWith('/partenaires') ? 'Espace partenaires' : p.startsWith('/admin') ? 'Administration' : p.startsWith('/r/') ? 'Résultat partagé' : 'Mesurio');
    document.title = `${t} — Mesurio`;
  });
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const share = $derived(router.match('/r/:id'));
  const slug = $derived(router.path.slice(1));
</script>

<Header />
<main id="contenu" tabindex="-1">
  {#key router.path}
  <div class="page" in:fly={{ y: 12, duration: reduce ? 0 : 280, opacity: 0 }}>
  {#if router.path === '/'}
    <TestPage />
  {:else if share}
    <SharePage id={share.id} />
  {:else if router.path === '/historique'}
    <HistoryPage />
  {:else if router.path === '/observatoire'}
    {#await Observatory() then m}<m.default />{/await}
  {:else if router.path === '/methodologie'}
    <MethodPage />
  {:else if legal.includes(slug)}
    <LegalPage {slug} />
  {:else if router.path.startsWith('/partenaires')}
    {#await Portal() then m}<m.default />{/await}
  {:else if router.path.startsWith('/admin')}
    {#await Admin() then m}<m.default />{/await}
  {:else}
    <NotFound />
  {/if}
  </div>
  {/key}
</main>
<Footer />
